<template>
  <master-layout v-bind:pageTitle="this.$t('signup')">
    <ion-page>
      <div class="whiterow" v-if="!message">
        <ion-card class="card-center">
          <ion-card-header>
            <ion-card-title>{{ $t('signup') }}</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <img
              id="profile-img"
              src="/assets/icon/default-avatar.svg"
              class="profile-img-card"
            />
            <Form @submit="handleRegister" :validation-schema="schema" v-if="!message">
              <div v-if="!successful">
                <div>
                  <label for="firstname">{{ $t('firstname') }}</label>
                  <Field name="firstname" type="text"  />
                  <ErrorMessage name="firstname" class="error-feedback" />
                </div>
                <div>
                  <label for="lastname">{{ $t('lastname') }}</label>
                  <Field name="lastname" type="text"  />
                  <ErrorMessage name="lastname" class="error-feedback" />
                </div>
                <div>
                  <label for="username">{{ $t('username') }}</label>
                  <Field name="username" type="text" />
                  <ErrorMessage name="username" class="error-feedback" />
                </div>
                <div>
                  <label for="email">{{ $t('email') }}</label>
                  <Field name="email" type="email"  />
                  <ErrorMessage name="email" class="error-feedback" />
                </div>
                <div>
                  <label for="password">{{ $t('password') }}</label>
                  <Field name="password" type="password" />
                  <ErrorMessage name="password" class="error-feedback" />
                </div>

                <div>
                  <ion-button :disabled="loading" type="submit">
                    <span
                      v-show="loading"
                      class="spinner-border spinner-border-sm"
                    ></span>
                    {{ $t('signup') }}
                  </ion-button>
                </div>
              </div>
            </Form>
          </ion-card-content>
        </ion-card>
      </div>
      <div class="whitespace" v-if="message"> 
        <ion-card>
          <ion-card-content>
            <div
              v-if="message"
            >
              {{ message }}
            </div>
          </ion-card-content>
        </ion-card>
      </div>
    </ion-page>
  </master-layout>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import { IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonButton, IonPage/*, IonTitle, IonToolbar */} from '@ionic/vue';

export default {
  name: "Register",
  components: {
    Form,
    Field,
    ErrorMessage,
    IonPage,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardContent,
    IonButton
  },
  data() {
    const schema = yup.object().shape({
      username: yup
        .string()
        .required("Username is required!")
        .min(3, "Must be at least 3 characters!")
        .max(20, "Must be maximum 20 characters!"),
      email: yup
        .string()
        .required("Email is required!")
        .email("Email is invalid!")
        .max(50, "Must be maximum 50 characters!"),
      password: yup
        .string()
        .required("Password is required!")
        .min(6, "Must be at least 6 characters!")
        .max(40, "Must be maximum 40 characters!"),
      firstname: yup
        .string()
        .required("Firstname is required!")
        .min(1, "Must be at least 1 character!")
        .max(20, "Must be maximum 20 characters!"),
      lastname: yup
        .string()
        .required("Lastname is required!")
        .min(1, "Must be at least 1 character!")
        .max(20, "Must be maximum 20 characters!"),
    });

    return {
      successful: false,
      loading: false,
      message: "",
      schema,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  mounted() {
    if (this.loggedIn) {
      this.$router.push("/profile");
    }
  },
  methods: {
    handleRegister(user) {
      this.message = "";
      this.successful = false;
      this.loading = true;

      this.$store.dispatch("auth/register", user).then(
        (data) => {
          this.message = data.message;
          this.successful = true;
          this.loading = false;
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.successful = false;
          this.loading = false;
        }
      );
    },
  },
};
</script>  
<style scoped>
  label {
    display: block;
    margin-top: 10px;
  }
  
  .profile-img-card {
    width: 96px;
    height: 96px;
    margin: 0 auto 10px;
    display: block;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
  }
</style>